export default class PromotionUtil {
  /** @type {Config|null} */
  __config
  /** @type {string} */
  __stockId
  /** @type {number} */
  __quantity
  /**
   * Description
   * @param {string} stockId
   * @param {Config} config
   */
  constructor(stockId, config) {
    this.__config = config
    this.__stockId = stockId
  }

  /**
   * Description
   * @param {number} quantity
   */
  setQuantity(quantity) {
    this.__quantity = quantity
  }

  getPromoItem() {
    if (!this.__config) return null
    const config = this.__config

    if (config?.promotionTypeCode === 'b1g1') {
      /** @type {PromoItem} */
      const promoItem = {
        code: config.code,
        stockId: this.__stockId,
        quantity: this.__quantity,
        type: config.promotionTypeName,
        typeCode: config.promotionTypeCode,
      }
      return promoItem
    }
    if (config?.promotionTypeCode === 'b1gx') {
      console.log(config)
      /** @type {PromoItem} */
      const promoItem = {
        typeCode: config.promotionTypeCode,
        code: config.code,
        quantity: this.__quantity * config.buyQty * Number(config.getQty),
        stockId: this.__stockId,
        type: config.promotionTypeName,
      }
      return promoItem
    }
    if (config?.promotionTypeCode === 'cross_freebie') {
      const freeQty = Math.floor(this.__quantity / config.buyQty || 1) * (config.free_qty || 1)
      /** @type {PromoItem} */
      const promoItem = {
        typeCode: config.promotionTypeCode,
        code: config.code,
        freebie: config.freeStock,
        freeStockId: config.free_stock_id,
        quantity: freeQty,
        stockId: this.__stockId,
        type: config.type,
      }
      return promoItem
    }
    if (config?.promotionTypeCode === 'fix_disc') {
      /** @type {PromoItem} */
      const promoItem = {
        typeCode: config.promotionTypeCode,
        code: config.code,
        fixedDiscount: config.amount,
        remarks: `Discount ₱${config.amount || 0} on each unit`,
        type: config.promotionTypeName,
      }
      return promoItem
    }
    if (config?.promotionTypeCode === 'pct_disc') {
      /** @type {PromoItem} */
      const promoItem = {
        typeCode: config.promotionTypeCode,
        code: config.code,
        percentDiscount: config.percent,
        remarks: `Discount ${config.percent || 0}% on each unit`,
        type: config.promotionTypeName,
      }
      return promoItem
    }
    if (config?.promotionTypeCode === 'x4y') {
      const toPayQty = Math.floor(this.__quantity / config.x || 1) * (config.y || 1)
      /** @type {PromoItem} */
      const promoItem = {
        typeCode: config.promotionTypeCode,
        code: config.code,
        quantity: this.__quantity - toPayQty,
        stockId: this.__stockId,
        type: config.promotionTypeName,
      }
      return promoItem
    }
    return null
  }

  /**
   * Description
   * @returns {{type: 'rate'|'fixed', value: number}|null}
   */
  getDiscount() {
    const promoItem = this.getPromoItem()
    if (!promoItem) return null
    if (promoItem.typeCode === 'pct_disc') {
      return {
        type: 'rate',
        value: promoItem.percentDiscount / 100,
      }
    }
    if (promoItem.typeCode === 'fix_disc') {
      return {
        type: 'fixed',
        value: promoItem.fixedDiscount,
      }
    }
    if (promoItem.typeCode === 'x4y') {
      return {
        type: 'rate',
        value: promoItem.quantity / this.__quantity,
      }
    }
    return null
  }
}

/**
 * @typedef {Object} PromoItemB1g1
 * @property {number} quantity
 * @property {string} stockId
 * @property {string} code
 * @property {string} type
 * @property {'b1g1'} typeCode
 * 
 * @typedef {Object} PromoItemB1gx
 * @property {number} quantity
 * @property {string} stockId
 * @property {string} code
 * @property {string} type
 * @property {'b1gx'} typeCode
 * 
 * @typedef {Object} PromoItemX4y
 * @property {number} quantity
 * @property {string} stockId
 * @property {string} code
 * @property {string} type
 * @property {'x4y'} typeCode
 * 
 * @typedef {Object} PromoItemCrossFreebie
 * @property {number} quantity
 * @property {string} stockId
 * @property {string} code
 * @property {string} freeStockId
 * @property {string} type
 * @property {'cross_freebie'} typeCode
 * @property {Record<string, any>} freebie
 * 
 * @typedef {Object} PromoItemPctDisc
 * @property {string} remarks
 * @property {number} percentDiscount
 * @property {string} code
 * @property {string} type
 * @property {'pct_disc'} typeCode
 * 
 * @typedef {Object} PromoItemFixDisc
 * @property {string} remarks
 * @property {number} fixedDiscount
 * @property {string} code
 * @property {string} type
 * @property {'fix_disc'} typeCode
 * 
 * @typedef {PromoItemB1g1|PromoItemB1gx|PromoItemCrossFreebie|PromoItemFixDisc|PromoItemPctDisc|PromoItemX4y|null} PromoItem
 * 
 * @typedef {Object} B1g1
 * @property {number} buyQty
 * @property {number} getQty
 * @property {'b1g1'} promotionTypeCode
 * @property {string} promotionTypeName
 * @property {string} code
 * 
 * @typedef {Object} B1gx
 * @property {number} buyQty
 * @property {number} getQty
 * @property {'b1gx'} promotionTypeCode
 * @property {string} promotionTypeName
 * @property {string} code
 * 
 * @typedef {Object} PctDisc
 * @property {number} percent
 * @property {'pct_disc'} promotionTypeCode
 * @property {string} promotionTypeName
 * @property {string} code
 * 
 * @typedef {Object} FixDisc
 * @property {number} amount
 * @property {'fix_disc'} promotionTypeCode
 * @property {string} promotionTypeName
 * @property {string} code
 * 
 * @typedef {Object} X4y
 * @property {number} x
 * @property {number} y
 * @property {'x4y'} promotionTypeCode
 * @property {string} promotionTypeName
 * @property {string} code
 * 
 * @typedef {Object} CrossFreebie
 * @property {number} buyQty
 * @property {number} free_qty
 * @property {string} free_stock_id
 * @property {'cross_freebie'} promotionTypeCode
 * @property {string} promotionTypeName
 * @property {string} code
 * @property {Record<string, any>} freeStock
 * 
 * @typedef {B1g1|B1gx|PctDisc|FixDisc|X4y|CrossFreebie} Config
 */